import { AccountRisksComponent } from './account-risks/account-risks.component';
import { AppReportComponent } from './app-report/app-report.component';
import { BaselineCategoriesComponent } from './baseline-categories/baseline-categories.component';
import { BlockedAccountsCardComponent } from './blocked-accounts-card/blocked-accounts-card.component';
import { ChangesHistoryComponent } from './changes-history/changes-history.component';
import { MailFlowComponent } from './mail-flow/mail-flow.component';
import { MonitoringComponent } from './monitoring/monitoring.component';
import { PwnedCheckComponent } from './pwned-check/pwned-check.component';
import { RemoteAccessComponent } from './remote-access/remote-access.component';
import { SwayComponent } from './sway/sway.component';

export const dashboardCards = {
    monitoring: MonitoringComponent,
    remoteAccess: RemoteAccessComponent,
    risks: AccountRisksComponent,
    mailFlow: MailFlowComponent,
    pwnedCheck: PwnedCheckComponent,
    changesHistory: ChangesHistoryComponent,
    blockedAccounts: BlockedAccountsCardComponent,
    sway: SwayComponent,
    baselineCategories: BaselineCategoriesComponent,
    appReport: AppReportComponent,
};
